import { PreviewText } from 'owa-locstrings/lib/strings/previewtext.locstring.json';
import loc from 'owa-localize';
import { previewSharePointDocumentLinkInSxS } from '../../actions/publicActions';
import { closeLinkContextMenu } from '../../components/LinkContextMenu';
import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';

import {
    lazyForceGetWacInfoOperation,
    lazyGetValidDocLinkPreviewInfo,
} from 'owa-doc-link-click-handler';

export function getLinkPreviewContextMenuItem(
    linkUrl: string,
    linkId: string,
    isCalendar: boolean,
    targetWindow: Window
): IContextualMenuItem | null {
    if (isCalendar) {
        return null;
    }

    return {
        name: loc(PreviewText),
        key: 'Preview',
        iconProps:
            isFeatureEnabled('wvn-chicletEditOptions') ||
            isFeatureEnabled('wvn-chicletEditOptionsNoDownload')
                ? { iconName: ControlIcons.DocumentSearch }
                : undefined,
        onClick: () => {
            previewLinkInSxS(linkUrl, linkId, targetWindow);
            closeLinkContextMenu();
        },
    };
}

async function previewLinkInSxS(linkUrl: string, linkId: string, targetWindow: Window) {
    logUsage('PreviewLinkInSxS');
    const getValidDocLinkPreviewInfo = await lazyGetValidDocLinkPreviewInfo.import();
    let docLinkPreviewInfo = getValidDocLinkPreviewInfo(linkUrl);
    if (!docLinkPreviewInfo || docLinkPreviewInfo.needRedeem) {
        // this means the getWacInfo operation succeeded more than 5 minutes ago
        // or the link needs to be redeemed
        // force a getWacInfo call to ensure the preview info is valid (not expired)
        const forceGetWacInfoOperation = await lazyForceGetWacInfoOperation.import();
        docLinkPreviewInfo = await forceGetWacInfoOperation(
            linkUrl,
            true /* shouldReturnDocLinkPreviewInfo */,
            true /* redeemSharingLinkIfNecessary */
        );
    }

    previewSharePointDocumentLinkInSxS(
        () => Promise.resolve(docLinkPreviewInfo.wacUrlInfo),
        linkId,
        docLinkPreviewInfo.wacUrlInfo.readOnly,
        targetWindow
    );
}
